import { commonLang, lang } from '@umu/ukit-lang';
import React, { Component } from 'react';
import { IAiDimensionData, IKeyVal } from '../../types';
import RadarChart from './components/radarChart/radarChart';
import LinearChart from './components/linearChart/linearChart';
import { columns } from './aiReportUtil';
import StarRating from '../../../starRating/starRating';
import './aiReportChart.scss';

interface IAiReportChartProps {
    avg: number;
    dimensions: IAiDimensionData;
    expressiveMinScore?: number;
    expressiveFullScore?: number;
    aiVoiceCheckSwitch?: number; // 是否开启
}

export default class AiReportChart extends Component<IAiReportChartProps, {}> {
    public render() {
        const { dimensions, avg, expressiveMinScore = 0 } = this.props;
        let { expressiveFullScore } = this.props;
        expressiveFullScore = expressiveFullScore || 5;
        const minScore = expressiveMinScore ? expressiveMinScore : 0;
        const fullScore = expressiveFullScore ? expressiveFullScore : 5;
        if (!dimensions) {
            return null;
        }
        const rate = Number(((avg / expressiveFullScore) * 5).toFixed(1));
        return (
            <div className="ai-report-chart">
                <div className="ai-report-star">
                    <StarRating rate={rate} score={avg} />
                </div>
                <div className="score-limit flex--center">
                    <span className="full-score">
                        {lang('AI表现力满分') + commonLang('：') + lang('{$0{0=分,1=分}}', String(fullScore))}
                    </span>
                    {minScore > 0 ? (
                        <span className="min-score">
                            {lang('最低提交分数') + commonLang('：') + lang('{$0{0=分,1=分}}', String(minScore))}
                        </span>
                    ) : null}
                </div>
                {this.renderChart()}
            </div>
        );
    }

    private renderChart = () => {
        const { dimensions, aiVoiceCheckSwitch } = this.props;
        const rangeMax = this.props.expressiveFullScore || 5;
        if (Object.keys(dimensions).length > 2) {
            const chatColumns = this.getRadarColumns(dimensions);
            const seriesData = this.getRadarSeries(dimensions);
            return (
                <div className="ai-report-radar">
                    <RadarChart
                        columns={chatColumns}
                        series={seriesData}
                        aiVoiceCheckSwitch={aiVoiceCheckSwitch}
                        rangeMax={rangeMax}
                    />
                </div>
            );
        } else {
            return <LinearChart dimensions={dimensions} aiVoiceCheckSwitch={aiVoiceCheckSwitch} fullScore={rangeMax} />;
        }
    };

    private getRadarColumns(dimensionsData: IAiDimensionData) {
        const columnsData: IKeyVal = {};
        const dimensionKeys = Object.keys(dimensionsData);
        for (const dimensionKey of dimensionKeys) {
            if (typeof dimensionKey !== 'undefined') {
                columnsData[dimensionKey] = columns[dimensionKey];
            }
        }
        return columnsData;
    }

    private getRadarSeries(dimensionsData: IAiDimensionData) {
        if (!dimensionsData) {
            return [];
        }
        const seriesData = [];
        const dimensionsKeys = Object.keys(dimensionsData);
        const seseriesValue: IKeyVal = {
            color: '#1E6EE6',
            class: 'seriese1',
        };
        for (const dimensionsKey of dimensionsKeys) {
            if (typeof dimensionsKey !== 'undefined') {
                seseriesValue[dimensionsKey] = dimensionsData[dimensionsKey];
            }
        }
        seriesData.push(seseriesValue);
        return seriesData;
    }
}
